import React from "react";
import {
    RiFileList3Fill,
    RiFileList3Line,
    RiFileTextFill,
    RiFileTextLine,
    RiGroupFill,
    RiGroupLine,
    RiLayoutGridFill,
    RiLayoutGridLine,
    RiLogoutBoxRFill,
    RiLogoutBoxRLine,
    RiSettings3Fill,
    RiSettings3Line,
    RiSurveyFill,
    RiSurveyLine,
    RiTodoFill,
    RiTodoLine,
} from "react-icons/ri";

/**
 * "areas" lista as áreas do painel (utils/PermissionUtils) que fazem a opção aparecer; sem "areas", aparece para todos.
 */

export const avatarMenuOptions = [
    {
        id: "Documentos",
        areas: ["documentos"],
        path: "/docs",
        icon: <RiFileList3Line size={18} />,
        activeIcon: <RiFileList3Fill size={18} />,
        label: "Documentos",
        labelComponent: null,
    },
    {
        id: "Configuracao",
        areas: ["empresa", "dadosDePagamento"],
        path: "/configuracoes",
        icon: <RiSettings3Line size={18} />,
        activeIcon: <RiSettings3Fill size={18} />,
        label: "Configurações",
        labelComponent: null,
    },
    {
        id: "global",
        path: "/termos-de-uso",
        icon: <RiFileTextLine size={18} />,
        activeIcon: <RiFileTextFill size={18} />,
        label: "Termos de Uso",
        labelComponent: null,
    },
    {
        id: "global",
        path: "/logout",
        icon: <RiLogoutBoxRLine size={18} />,
        activeIcon: <RiLogoutBoxRFill size={18} />,
        label: "Sair",
        labelComponent: null,
    },
];

export const headerMenuOptions = [
    {
        id: "Dashboard",
        areas: ["dashboard", "engajamento"],
        path: "/dashboard",
        icon: <RiLayoutGridLine size={18} />,
        activeIcon: <RiLayoutGridFill size={18} />,
        label: "Dashboard",
        subMenu: null,
    },
    {
        id: "GruposDeUsuario;Usuarios;Team",
        areas: ["usuarios", "equipes", "gruposDeUsuario"],
        path: "/acessos",
        icon: <RiGroupLine size={18} />,
        activeIcon: <RiGroupFill size={18} />,
        label: "Equipes",
        subMenu: null,
    },
    {
        id: "Pesquisas",
        areas: ["pesquisas"],
        path: "/pesquisas",
        icon: <RiSurveyLine size={18} />,
        activeIcon: <RiSurveyFill size={18} />,
        label: "Pesquisas",
    },
    {
        id: "PlanosDeAcao",
        areas: ["planosDeAcao"],
        path: "/planos-de-acao",
        icon: <RiTodoLine size={18} />,
        activeIcon: <RiTodoFill size={18} />,
        label: "Planos de Ação",
    },
];
